/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AuthLoginPersonalPost$Params {
  AuthorizedParty?: string;
  EmailAdmin?: string;
  Tel?: string;
  ReturnUrl?: string;
  ResultMsg?: string;
  IsError?: boolean;
}

export function authLoginPersonalPost(http: HttpClient, rootUrl: string, params?: AuthLoginPersonalPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, authLoginPersonalPost.PATH, 'post');
  if (params) {
    rb.query('AuthorizedParty', params.AuthorizedParty, {});
    rb.query('EmailAdmin', params.EmailAdmin, {});
    rb.query('Tel', params.Tel, {});
    rb.query('ReturnUrl', params.ReturnUrl, {});
    rb.query('ResultMsg', params.ResultMsg, {});
    rb.query('IsError', params.IsError, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

authLoginPersonalPost.PATH = '/auth/login-personal';
